import { defaultFeatures } from 'constants/features';
import { Action } from 'redux';

import {
    FeatureActionType,
    SetFeatureActiveAction,
    SetFeaturesActiveAction,
} from './features.actions';

export const initialState = defaultFeatures;

export const featuresReducer = (
    state = initialState,
    action: Action<FeatureActionType>,
): typeof initialState => {
    switch (action.type) {
        case FeatureActionType.SetFeaturesActive:
            const activeFeatures = (action as SetFeaturesActiveAction).payload;
            return {
                ...state,
                ...activeFeatures,
            };

        case FeatureActionType.SetFeatureActive:
            const [feature, enabled] = (action as SetFeatureActiveAction).payload;
            return {
                ...state,
                [feature]: enabled,
            };

        default:
            return state;
    }
};
